export default {"src":"/_next/static/media/purina-white.32bee9ae.svg","height":36,"width":112,"blurWidth":0,"blurHeight":0};